import { useState } from 'react';
import jMoment from 'moment-jalaali';
import InitFilters from './constants/InitFiltering';
import {useCurrencyUnit} from 'hooks'

const useCustomHook = () => {
  const currencyText = useCurrencyUnit(false);
  const [isOpen, setIsOpen] = useState(false);
  const [datePayment, setDatePayment] = useState(jMoment());
  const [loading, setLoading] = useState(false);
  const [link, setLink] = useState(null);
  const [filters, setFilters] = useState(InitFilters(currencyText));
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [filterParams, setFilterParams] = useState(null);
  const [isPaymentLinkOpen, setIsPaymentLinkOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [isOpenDialog, setIsOpenDialog] = useState(false);


  const [more, setMore] = useState(false);
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [openSnack, setOpenSnack] = useState(false);
  const [isOpenMessageCartableDg, setIsOpenMessageCartableDg] = useState(false);
  const [requestId, setRequestId] = useState(null);

  return {
    more, setMore,
    data, setData,
    isLoading, setIsLoading,
    openSnack, setOpenSnack,
    page, setPage,
    filters, setFilters,
    size, setSize,
    filterParams, setFilterParams,
    isPaymentLinkOpen, setIsPaymentLinkOpen,
    selectedInvoice, setSelectedInvoice,
    isOpenDialog, setIsOpenDialog,
    loading, setLoading,
    link, setLink,
    isOpen,
    setIsOpen,
    datePayment,
    setDatePayment,
    isOpenMessageCartableDg, setIsOpenMessageCartableDg,
    requestId, setRequestId
  };
};

export default useCustomHook;
